export const TYPE_COLORS = {
  INTJ: { bg:'#EDE9FE', accent:'#7C3AED', border:'#C4B5FD' },
  INTP: { bg:'#DBEAFE', accent:'#2563EB', border:'#93C5FD' },
  ENTJ: { bg:'#FFE4E6', accent:'#E11D48', border:'#FECDD3' },
  ENTP: { bg:'#FFEDD5', accent:'#EA580C', border:'#FED7AA' },
  INFJ: { bg:'#DCFCE7', accent:'#16A34A', border:'#86EFAC' },
  INFP: { bg:'#EDE9FE', accent:'#7C3AED', border:'#C4B5FD' },
  ENFJ: { bg:'#CCFBF1', accent:'#0D9488', border:'#5EEAD4' },
  ENFP: { bg:'#FFEDD5', accent:'#EA580C', border:'#FED7AA' },
  ISTJ: { bg:'#DBEAFE', accent:'#2563EB', border:'#93C5FD' },
  ISFJ: { bg:'#DCFCE7', accent:'#16A34A', border:'#86EFAC' },
  ESTJ: { bg:'#FFE4E6', accent:'#E11D48', border:'#FECDD3' },
  ESFJ: { bg:'#CCFBF1', accent:'#0D9488', border:'#5EEAD4' },
  ISTP: { bg:'#DBEAFE', accent:'#2563EB', border:'#93C5FD' },
  ISFP: { bg:'#CCFBF1', accent:'#0D9488', border:'#5EEAD4' },
  ESTP: { bg:'#FFE4E6', accent:'#E11D48', border:'#FECDD3' },
  ESFP: { bg:'#FFEDD5', accent:'#EA580C', border:'#FED7AA' },
};

// Card rank + suit assignment
// Aces=Analytiker ♠♥♦♣, Kings=Wächter, Queens=Diplomaten, Jacks=Forscher
export const TYPE_CARD = {
  INTJ: { rank:'A', suit:'♠', suitName:'Pik',    rankName:'Ass'   },
  INTP: { rank:'A', suit:'♥', suitName:'Herz',   rankName:'Ass'   },
  ENTJ: { rank:'A', suit:'♦', suitName:'Karo',   rankName:'Ass'   },
  ENTP: { rank:'A', suit:'♣', suitName:'Kreuz',  rankName:'Ass'   },
  ISTJ: { rank:'K', suit:'♠', suitName:'Pik',    rankName:'König' },
  ISFJ: { rank:'K', suit:'♥', suitName:'Herz',   rankName:'König' },
  ESTJ: { rank:'K', suit:'♦', suitName:'Karo',   rankName:'König' },
  ESFJ: { rank:'K', suit:'♣', suitName:'Kreuz',  rankName:'König' },
  INFJ: { rank:'Q', suit:'♠', suitName:'Pik',    rankName:'Dame'  },
  INFP: { rank:'Q', suit:'♥', suitName:'Herz',   rankName:'Dame'  },
  ENFJ: { rank:'Q', suit:'♦', suitName:'Karo',   rankName:'Dame'  },
  ENFP: { rank:'Q', suit:'♣', suitName:'Kreuz',  rankName:'Dame'  },
  ISTP: { rank:'J', suit:'♠', suitName:'Pik',    rankName:'Bube'  },
  ISFP: { rank:'J', suit:'♥', suitName:'Herz',   rankName:'Bube'  },
  ESTP: { rank:'J', suit:'♦', suitName:'Karo',   rankName:'Bube'  },
  ESFP: { rank:'J', suit:'♣', suitName:'Kreuz',  rankName:'Bube'  },
};

export const TYPES = {
  INTJ: { code:'INTJ', name:'Der Architekt', emoji:'🏛️', tagline:'Visionär · Strategisch · Unaufhaltsam', category:'Analytiker',
    description:'Du denkst in Systemen, wo andere nur Chaos sehen. Als INTJ bist du einer der seltensten Typen – und einer der wirkungsvollsten. Du planst nicht für morgen, du planst für das nächste Jahrzehnt.',
    strengths:['Strategisches Denken','Selbstdisziplin','Unabhängigkeit','Entschlossenheit'],
    challenges:['Emotionale Offenheit','Ungeduld mit anderen','Perfektionismus'],
    famous:['Elon Musk','Friedrich Nietzsche','Arnold Schwarzenegger'], percent:'2%', rarity:'Sehr selten' },
  INTP: { code:'INTP', name:'Der Denker', emoji:'🔬', tagline:'Analytisch · Neugierig · Präzise', category:'Analytiker',
    description:'Dein Gehirn schläft nie wirklich. Du entwickelst Theorien, hinterfragst Systeme und suchst nicht nach Antworten – du suchst nach den richtigen Fragen.',
    strengths:['Logisches Denken','Kreativität','Objektivität','Wissensdurst'],
    challenges:['Prokrastination','Soziale Signale','Entscheidungsfindung'],
    famous:['Albert Einstein','Charles Darwin','Bill Gates'], percent:'3%', rarity:'Selten' },
  ENTJ: { code:'ENTJ', name:'Der Kommandeur', emoji:'⚡', tagline:'Führungsstark · Direkt · Zielstrebig', category:'Analytiker',
    description:'Du siehst eine Aufgabe und weißt sofort, wer sie am besten erledigt – meistens du. ENTJs sind geborene Führungspersönlichkeiten die Effizienz über alles stellen.',
    strengths:['Führungsqualitäten','Effizienz','Selbstvertrauen','Entschlossenheit'],
    challenges:['Empathie','Geduld','Zuhören'],
    famous:['Steve Jobs','Margaret Thatcher','Gordon Ramsay'], percent:'3%', rarity:'Selten' },
  ENTP: { code:'ENTP', name:'Der Erfinder', emoji:'💡', tagline:'Innovativ · Provokant · Brillant', category:'Analytiker',
    description:'Regeln sind für dich Vorschläge. Als ENTP liebst du es Ideen zu zerlegen und findest die beste Lösung wo andere aufgeben.',
    strengths:['Innovation','Debattieren','Anpassungsfähigkeit','Charisma'],
    challenges:['Fokus','Routine','Projekte abschließen'],
    famous:['Leonardo da Vinci','Benjamin Franklin','Barack Obama'], percent:'3%', rarity:'Selten' },
  INFJ: { code:'INFJ', name:'Der Advokat', emoji:'🌿', tagline:'Intuitiv · Tief · Idealistisch', category:'Diplomat',
    description:'Du weißt oft was Menschen fühlen, bevor sie es selbst aussprechen. INFJ ist der seltenste Persönlichkeitstyp – du trägst eine stille innere Welt in dir.',
    strengths:['Empathie','Intuition','Kreativität','Zielgerichtetheit'],
    challenges:['Überempfindlichkeit','Perfektionismus','Burnout-Risiko'],
    famous:['Martin Luther King Jr.','Nelson Mandela','Lady Gaga'], percent:'1%', rarity:'Äußerst selten' },
  INFP: { code:'INFP', name:'Der Mediator', emoji:'🎨', tagline:'Kreativ · Empathisch · Werteorientiert', category:'Diplomat',
    description:'Du lebst nach deinen inneren Werten und kompromittierst sie für niemanden. Als INFP bist du ein stiller Träumer mit enormer emotionaler Tiefe.',
    strengths:['Empathie','Kreativität','Authentizität','Leidenschaft'],
    challenges:['Selbstkritik','Grenzen setzen','Pragmatismus'],
    famous:['J.R.R. Tolkien','Johnny Depp','Audrey Hepburn'], percent:'4%', rarity:'Selten' },
  ENFJ: { code:'ENFJ', name:'Der Protagonist', emoji:'🌟', tagline:'Inspirierend · Charismatisch · Fürsorglich', category:'Diplomat',
    description:'Menschen folgen dir weil du etwas in ihnen entzündest. ENFJs sind natürliche Mentoren die das Potenzial in jedem Menschen sehen.',
    strengths:['Kommunikation','Empathie','Führung','Zuverlässigkeit'],
    challenges:['Überengagement','Eigene Bedürfnisse','Kritik'],
    famous:['Barack Obama','Oprah Winfrey','Goethe'], percent:'2%', rarity:'Selten' },
  ENFP: { code:'ENFP', name:'Der Aktivist', emoji:'🦋', tagline:'Enthusiastisch · Kreativ · Verbindend', category:'Diplomat',
    description:'Du siehst überall Möglichkeiten wo andere Hindernisse sehen. ENFPs bringen Energie in jeden Raum und verbinden Menschen auf einzigartige Weise.',
    strengths:['Enthusiasmus','Kreativität','Empathie','Kommunikation'],
    challenges:['Fokus','Übercommitment','Routine'],
    famous:['Robin Williams','Walt Disney','Anne Frank'], percent:'7%', rarity:'Häufig' },
  ISTJ: { code:'ISTJ', name:'Der Inspektor', emoji:'🏗️', tagline:'Zuverlässig · Methodisch · Pflichtbewusst', category:'Wächter',
    description:'Du bist der Fels in der Brandung. ISTJs halten die Welt am Laufen durch Verlässlichkeit, Struktur und unerschütterliches Pflichtgefühl.',
    strengths:['Zuverlässigkeit','Gründlichkeit','Integrität','Praktisch'],
    challenges:['Flexibilität','Neue Ideen','Emotionaler Ausdruck'],
    famous:['Angela Merkel','Sigmund Freud','Warren Buffett'], percent:'13%', rarity:'Häufig' },
  ISFJ: { code:'ISFJ', name:'Der Beschützer', emoji:'🛡️', tagline:'Fürsorglich · Loyal · Beständig', category:'Wächter',
    description:'Du erinnerst dich an den Geburtstag jedes Menschen den du liebst. ISFJs sind die stillen Helden des Alltags – immer da, immer verlässlich.',
    strengths:['Fürsorge','Geduld','Detailgenauigkeit','Loyalität'],
    challenges:['Grenzen setzen','Veränderung','Eigene Bedürfnisse'],
    famous:['Mutter Teresa','Kate Middleton','Halle Berry'], percent:'13%', rarity:'Häufig' },
  ESTJ: { code:'ESTJ', name:'Der Manager', emoji:'📋', tagline:'Organisiert · Direkt · Verantwortungsvoll', category:'Wächter',
    description:'Chaos ist dein Feind. Als ESTJ weißt du wie Dinge funktionieren sollten und sorgst dafür dass sie es tun.',
    strengths:['Organisation','Führung','Zuverlässigkeit','Direktheit'],
    challenges:['Flexibilität','Emotionen anderer','Kompromisse'],
    famous:['Hillary Clinton','Frank Sinatra','Sheryl Sandberg'], percent:'11%', rarity:'Häufig' },
  ESFJ: { code:'ESFJ', name:'Der Konsul', emoji:'🤝', tagline:'Warmherzig · Sozial · Fürsorglich', category:'Wächter',
    description:'Dein Zuhause ist immer offen, dein Herz noch mehr. ESFJs schaffen Harmonie wo andere Konflikt sehen.',
    strengths:['Soziale Kompetenz','Fürsorge','Verlässlichkeit','Loyalität'],
    challenges:['Kritik','Grenzen','Eigenständigkeit'],
    famous:['Taylor Swift','Bill Clinton','Jennifer Garner'], percent:'12%', rarity:'Häufig' },
  ISTP: { code:'ISTP', name:'Der Virtuose', emoji:'🔧', tagline:'Pragmatisch · Kühl · Handwerklich', category:'Forscher',
    description:'Du verstehst wie Dinge funktionieren durch Anfassen und Ausprobieren. ISTPs sind Meister des praktischen Denkens.',
    strengths:['Problemlösung','Kühlheit unter Druck','Praktisches Denken','Flexibilität'],
    challenges:['Langzeit-Commitment','Emotionen','Struktur'],
    famous:['Clint Eastwood','Bear Grylls','Scarlett Johansson'], percent:'5%', rarity:'Selten' },
  ISFP: { code:'ISFP', name:'Der Abenteurer', emoji:'🌸', tagline:'Sensibel · Künstlerisch · Frei', category:'Forscher',
    description:'Du lebst im Moment und weißt wie man ihn wirklich erlebt. ISFPs sehen Schönheit überall und folgen ihrem Herzen.',
    strengths:['Ästhetisches Gespür','Empathie','Anpassungsfähigkeit','Authentizität'],
    challenges:['Zukunftsplanung','Konfrontation','Selbstvertrauen'],
    famous:['Michael Jackson','Bob Dylan','Frida Kahlo'], percent:'8%', rarity:'Gelegentlich' },
  ESTP: { code:'ESTP', name:'Der Unternehmer', emoji:'🚀', tagline:'Energetisch · Direkt · Risikofreudig', category:'Forscher',
    description:'Du denkst nicht nach – du handelst. ESTPs leben im Hier und Jetzt mit einer Energie die andere mitreißt.',
    strengths:['Risikobereitschaft','Energie','Direktheit','Krisenmanagement'],
    challenges:['Langzeitplanung','Sensibilität','Regeln'],
    famous:['Ernest Hemingway','Madonna','Mike Tyson'], percent:'4%', rarity:'Selten' },
  ESFP: { code:'ESFP', name:'Der Entertainer', emoji:'🎭', tagline:'Spontan · Energetisch · Lebensfroh', category:'Forscher',
    description:'Das Leben ist eine Bühne – und du liebst es darauf zu stehen. ESFPs bringen Licht in jeden Raum.',
    strengths:['Spontaneität','Energie','Begeisterungsfähigkeit','Menschenkenntnis'],
    challenges:['Planung','Ernsthaftigkeit','Langzeitfokus'],
    famous:['Adele','Jamie Oliver','Marilyn Monroe'], percent:'8%', rarity:'Gelegentlich' },
};

export const QUESTIONS = [
  { id:1,  dim:'EI', text:'Du wirst spontan zu einer Party eingeladen. Deine erste Reaktion ist...',
    a:'Großartig! Ich freue mich auf neue Gespräche und Menschen.',
    b:'Ich überlege erst ob ich wirklich Lust habe — meistens lieber nicht.' },
  { id:2,  dim:'EI', text:'Nach einem stressigen Arbeitstag erholst du dich am besten durch...',
    a:'Treffen mit Freunden oder Familie — das lädt mich auf.',
    b:'Allein sein, lesen oder einen ruhigen Abend zuhause.' },
  { id:3,  dim:'EI', text:'In einer Diskussion mit mehreren Personen...',
    a:'bringe ich meine Meinung direkt ein und rede gerne.',
    b:'höre ich erst zu und melde mich nur wenn ich etwas Wichtiges beitragen kann.' },
  { id:4,  dim:'EI', text:'Neue Menschen kennenzulernen ist für dich...',
    a:'aufregend — ich liebe es verschiedene Persönlichkeiten zu entdecken.',
    b:'anstrengend — ich brauche danach Zeit für mich.' },
  { id:5,  dim:'EI', text:'Wenn du an einem Projekt arbeitest, bevorzugst du...',
    a:'enge Zusammenarbeit im Team mit viel Austausch.',
    b:'konzentriertes Arbeiten alleine mit minimalen Unterbrechungen.' },
  { id:6,  dim:'SN', text:'Wenn du eine neue Stadt besuchst, interessiert dich mehr...',
    a:'konkrete Sehenswürdigkeiten, Restaurants und lokale Fakten.',
    b:'die Atmosphäre, Geschichte und was die Stadt über ihre Menschen aussagt.' },
  { id:7,  dim:'SN', text:'Bei einem Problem vertraust du eher...',
    a:'bewährten Methoden die nachweislich funktionieren.',
    b:'deinem Instinkt und neuen kreativen Lösungsansätzen.' },
  { id:8,  dim:'SN', text:'Gespräche über abstrakte Theorien und Zukunftsvisionen sind für dich...',
    a:'oft zu weit von der Realität entfernt — ich bleibe lieber beim Konkreten.',
    b:'faszinierend — ich kann stundenlang über Ideen und Möglichkeiten reden.' },
  { id:9,  dim:'SN', text:'Wenn du eine Anleitung liest...',
    a:'folge ich ihr Schritt für Schritt — das gibt mir Sicherheit.',
    b:'überspringe ich Teile und versuche das Gesamtbild zuerst zu verstehen.' },
  { id:10, dim:'SN', text:'In 10 Jahren siehst du dich eher...',
    a:'in einer stabilen, gut geplanten Situation die auf soliden Grundlagen basiert.',
    b:'in einer komplett anderen, aufregenden Lebenssituation die ich heute noch nicht kenne.' },
  { id:11, dim:'TF', text:'Ein guter Freund trifft eine Entscheidung die du für falsch hältst. Du...',
    a:'sagst ihm ehrlich deine Meinung mit Fakten und Argumenten.',
    b:'unterstützt ihn trotzdem weil seine Gefühle und Autonomie wichtig sind.' },
  { id:12, dim:'TF', text:'Bei einer schwierigen Entscheidung verlässt du dich mehr auf...',
    a:'logische Analyse — was ergibt objektiv am meisten Sinn?',
    b:'dein Bauchgefühl — was fühlt sich für alle Beteiligten richtig an?' },
  { id:13, dim:'TF', text:'Wenn jemand dir sein Problem erzählt, reagierst du instinktiv mit...',
    a:'konkreten Lösungsvorschlägen und praktischen Ratschlägen.',
    b:'Empathie und dem Wunsch die Person emotional zu unterstützen.' },
  { id:14, dim:'TF', text:'Kritik an deiner Arbeit nimmst du eher wahr als...',
    a:'nützliches Feedback das mich weiterbringt — Emotionen spielen keine Rolle.',
    b:'etwas das mich persönlich berührt — auch wenn ich weiß dass es konstruktiv ist.' },
  { id:15, dim:'TF', text:'Bei Gruppenentscheidungen ist dir wichtiger...',
    a:'dass die beste und rationalste Lösung gewählt wird.',
    b:'dass alle mit der Entscheidung einverstanden sind und sich wohlfühlen.' },
  { id:16, dim:'JP', text:'Dein Wochenende ist frei. Du bevorzugst...',
    a:'einen klaren Plan — ich weiß gerne im Voraus was ich wann mache.',
    b:'spontan entscheiden — die besten Erlebnisse entstehen ungeplant.' },
  { id:17, dim:'JP', text:'Eine wichtige Aufgabe steht an. Du erledigst sie...',
    a:'so früh wie möglich — offene Aufgaben machen mich unruhig.',
    b:'wenn die Deadline näher rückt — dann bin ich am produktivsten.' },
  { id:18, dim:'JP', text:'Dein Arbeitsbereich ist eher...',
    a:'ordentlich und strukturiert — alles hat seinen festen Platz.',
    b:'funktional chaotisch — ich weiß wo alles ist auch wenn es unordentlich wirkt.' },
  { id:19, dim:'JP', text:'Wenn Pläne kurzfristig geändert werden...',
    a:'stresst mich das — ich brauche Struktur und Vorhersehbarkeit.',
    b:'ist das für mich meist kein Problem — ich passe mich gerne an.' },
  { id:20, dim:'JP', text:'Ein Projekt gilt für dich als...',
    a:'abgeschlossen sobald alle Punkte erledigt sind — dann kann ich loslassen.',
    b:'immer noch offen für Verbesserungen — es gibt immer etwas zu optimieren.' },
  { id:21, dim:'EI', text:'Wenn du eine schwierige Entscheidung treffen musst...',
    a:'besprichst du sie mit anderen — externe Perspektiven helfen dir.',
    b:'denkst du erst lange alleine darüber nach bevor du mit jemandem redest.' },
  { id:22, dim:'SN', text:'Bücher und Filme die dir gefallen sind eher...',
    a:'realistisch und nah an der Wirklichkeit — mit konkreten Charakteren.',
    b:'spekulativ und kreativ — Science-Fiction, Fantasy oder tiefe Metaphern.' },
  { id:23, dim:'TF', text:'Was motiviert dich mehr bei der Arbeit?',
    a:'Effizienz steigern und messbare Ergebnisse erzielen.',
    b:'Menschen helfen und einen positiven Einfluss auf andere haben.' },
  { id:24, dim:'JP', text:'Beim Reisen buchst du lieber...',
    a:'alles im Voraus — Hotel, Aktivitäten, Restaurants.',
    b:'nur das Nötigste und lässt den Rest offen für spontane Entdeckungen.' },
  { id:25, dim:'EI', text:'In einer stillen Umgebung ohne Menschen fühlst du dich...',
    a:'auf Dauer unwohl — ich brauche soziale Interaktion um Energie zu haben.',
    b:'wohl und aufgeladen — Stille gibt mir Kraft und Klarheit.' },
];

export function calculateType(answers) {
  const scores = { E:0, I:0, S:0, N:0, T:0, F:0, J:0, P:0 };
  answers.forEach(({ dim, choice }) => {
    const [a, b] = dim.split('');
    if (choice === 'a') scores[a]++; else scores[b]++;
  });
  return (scores.E > scores.I ? 'E':'I') + (scores.S > scores.N ? 'S':'N') +
         (scores.T > scores.F ? 'T':'F') + (scores.J > scores.P ? 'J':'P');
}


// ── A/T DIMENSION: Assertive vs Turbulent ────────────────────────────────────
// 5 dedicated questions measuring identity stability / stress response
// A = calm, confident, stress-resistant
// T = ambitious, self-critical, improvement-driven
export const AT_QUESTIONS = [
  { id:26, dim:'AT',
    text:'Wenn etwas schiefläuft, wie reagierst du meistens?',
    a:'Ich analysiere kurz was passiert ist und mache weiter — es ist ok.',
    b:'Ich beschäftige mich lange damit, grübele und mache mir Vorwürfe.' },
  { id:27, dim:'AT',
    text:'Wie gehst du mit Kritik um?',
    a:'Ich höre zu, nehme mit was nützlich ist, und lasse den Rest los.',
    b:'Kritik beschäftigt mich länger — ich will verstehen ob ich wirklich einen Fehler gemacht habe.' },
  { id:28, dim:'AT',
    text:'Wenn du ein Ziel nicht erreichst...',
    a:'akzeptiere ich das relativ schnell und setze neue Ziele.',
    b:'motiviert mich das, es beim nächsten Mal besser zu machen — ich lasse nicht locker.' },
  { id:29, dim:'AT',
    text:'Wie würdest du deinen allgemeinen Stresslevel beschreiben?',
    a:'Ich bin meistens ruhig und ausgeglichen — Stress ist die Ausnahme.',
    b:'Ich stehe oft unter Druck — entweder von außen oder durch eigene Ansprüche.' },
  { id:30, dim:'AT',
    text:'Wie sicher bist du dir in deinen Entscheidungen?',
    a:'Meistens sehr sicher — wenn ich entscheide, stehe ich dazu.',
    b:'Ich hinterfrage meine Entscheidungen oft im Nachhinein.' },
];

// A answers = Assertive, B answers = Turbulent
export function calculateAT(atAnswers) {
  let a = 0, b = 0;
  atAnswers.forEach(({ choice }) => {
    if (choice === 'a') a++; else b++;
  });
  return a >= b ? 'A' : 'T';
}
